// src/app/app.ts

import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { MediaLightboxComponent } from '@shared/components/media/gallery/media-lightbox/media-lightbox.component';
import { CurrentUserBootstrapService } from './core/session/current-user-bootstrap.service';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
  imports: [
    RouterOutlet,
    MediaLightboxComponent
  ]
})
export class AppComponent implements OnInit {
  title = 'portal-deweloper-frontend';
  private primeng = inject(PrimeNG);
  private currentUserBootstrap = inject(CurrentUserBootstrapService);

  async ngOnInit(): Promise<void> {
    this.primeng.setTranslation({
      dayNames: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
      dayNamesShort: ["Nie", "Pon", "Wto", "Śro", "Czw", "Pią", "Sob"],
      dayNamesMin: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "Sb"],
      monthNames: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
      monthNamesShort: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
      today: "Dzisiaj",
      clear: "Wyczyść"
    });

    this.currentUserBootstrap.initializeMsalSessionRuntime();
  }
}
